import React from 'react';
import $ from '../../../common/AjaxRequest';
import { Table, Modal, Button, DatePicker, message } from 'antd';
import API_URL from '../../../common/url';
import Highcharts from 'react-highcharts';
import chartsConfig from '../../common/chartsConfig';
import ExportUtil from '../../../common/ExportUtil';
import moment from 'moment';

const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class StartUpCharts extends React.Component {
    state = {
        data: [],
        searchParams: {},
    }

    show = (hospitalId) => {
        const { searchParams: { diseaseId = '', investigationAreaId = '' } } = this.props;
        this.setState({
            visible: true,
            searchParams: {
                diseaseId,
                hospitalId,
                investigationAreaId,
                startMonth: moment().subtract(11, 'M').format(monthFormat),
                endMonth: moment().format(monthFormat),
            },
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = () => {
        const { searchParams, searchParams: { startMonth, endMonth } } = this.state;
        if (!startMonth || !endMonth) {
            message.warning('请选择需要统计的月份');
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.competeCompany.queryHospitalAvgBeginDayTrend,
            data: {
                ...searchParams,
            },
            dateType: 'json',
            doneResult: res => {
                this.setState({
                    loading: false,
                    data: res.data,
                });
            }
        }
        $.sendRequest(options);
    }

    onMonthChange = (date, dateString, field) => {
        const { searchParams } = this.state;
        searchParams[field] = dateString;
        this.setState({ searchParams });
    }

    getColumns = () => {
        const { data } = this.state;
        const columns = [{
            title: '',
            dataIndex: 'index',
            width: 95,
        }];
        data.forEach(item => {
            columns.push({
                title: item.month,
                dataIndex: item.month,
                width: 85,
            })
        });
        return columns
    }

    getdataSource = () => {
        const { data } = this.state;
        const dataSource = [];
        const params = { index: '平均启动时长' };
        data.forEach(item => {
            params[item.month] = item.avgBeginDay;
        });
        dataSource.push(params);
        return dataSource;
    }

    componentDidMount() {
        chartsConfig.exporting.buttons.contextButton.menuItems = [
            'downloadJPEG', 'downloadPDF', 'downloadPNG', 'downloadSVG', 'label',
        ];
        chartsConfig.exporting.menuItemDefinitions.label = {
            onclick: () => {
              const { searchParams } = this.state;
              let url = API_URL.competeCompany.exportHospitalAvgBeginDayTrend;
              ExportUtil.export({ ...searchParams }, null, url);
            },
            text: '导出Excel'
        };
    }

    getChartConfig = () => {
        const { data } = this.state;
        let month = [];
        let dataList = [];
        data.forEach(item => {
            month.push(item.month);
            dataList.push(item.avgBeginDay);
        })
        return {
            title: {
                text: ''
            },
            chart: {
                type: 'line'
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                x: 0,
                y: 20,
                layout: 'vertical',
            },
            yAxis: {
                title: {
                    text: ''
                },
            },
            xAxis: {
                categories: month
            },
            series: [{
                data: dataList,
                name: '平均启动时长(天)'
            }],
            exporting: {
                chartOptions: {
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true
                            }
                        }
                    }
                }
            },
            credits: {
                enabled: false,
            },
        };
    }

    disabledBeginDate = (current) => {
        const { searchParams: { endMonth } } = this.state;
        return endMonth && (current.valueOf() < moment(endMonth).subtract(11, 'M').valueOf() || current.valueOf() >= moment(endMonth).add(1, 'M').valueOf());
    }

    disabledEndDate = (current) => {
        const { searchParams: { startMonth } } = this.state;
        return startMonth && (current.valueOf() < moment(startMonth).valueOf() || current.valueOf() >= moment(startMonth).add(12, 'M').valueOf());
    }

    render() {
        const { data, loading, visible, searchParams: { startMonth, endMonth } } = this.state;
        const newStartMonth = startMonth ? moment(startMonth) : null;
        const newEndMonth = endMonth ? moment(endMonth) : null;
        const scrollX = data.length > 7 ? data.length * 85 + 105 : 740;
        return (
            <Modal
                title="平均启动时长趋势图"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="800px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div style={{ padding: '0px 20px 30px' }}>
                    <h3 style={{ fontSize: '16px', lineHeight: '48px', textAlign: 'center' }}>平均启动时长</h3>
                    <div style={{ marginBottom: 20 }}>
                        <MonthPicker
                            format={monthFormat}
                            placeholder="请输入"
                            value={newStartMonth}
                            style={{width: 120}}
                            disabledDate={this.disabledBeginDate}
                            onChange={(date, dateString) => this.onMonthChange(date, dateString, 'startMonth')}
                        />
                        <span className="ant-divider" />
                        <MonthPicker
                            format={monthFormat}
                            placeholder="请输入"
                            value={newEndMonth}
                            style={{width: 120}}
                            disabledDate={this.disabledEndDate}
                            onChange={(date, dateString) => this.onMonthChange(date, dateString, 'endMonth')}
                        />
                        <Button type='primary' style={{ marginLeft: 10 }} onClick={this.loadData}>统计</Button>
                    </div>
                    <div className="charts" style={{ marginBottom: 10 }}>
                        <Highcharts config={{ ...this.getChartConfig(), ...chartsConfig }} />
                    </div>
                    <div className="content">
                        <Table
                            columns={this.getColumns()}
                            dataSource={this.getdataSource()}
                            rowKey={record => record.index}
                            scroll={{ x: scrollX }}
                            loading={loading}
                            pagination={false}
                            bordered
                        />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default StartUpCharts;



// WEBPACK FOOTER //
// ./src/components/hospital/hospitalInfo/StartUpCharts.js